// extracted by mini-css-extract-plugin
export default {"sectionview":"c085595505a2b35a2b0f","notice":"dc2f314e6df1a51c8c63","icon":"c9f2c8db99a4c224d699","body":"be267cb6198f9e19e6fe"};